@if (isOpen) {
  <div class="dc-modal">
    <div
      class="dc-modal-container notice-modal-container bg-white p-0!"
      [style.max-width]="maxWidth"
    >
      <button class="modal-x-button text-gray-500!" type="button" (click)="close()">
        <i class="fas fa-close"></i>
      </button>

      <div class="notice-modal-content">
        @if (title) {
          <div class="px-6 pt-6">
            <h2 class="text-xl font-semibold text-dc-navy">{{ title }}</h2>
          </div>
        }

        @if (imageSrc) {
          <img
            class="notice-modal-image"
            [src]="imageSrc"
            [alt]="imageAlt || title || 'Notice'"
          />
        }

        <ng-content></ng-content>
      </div>
    </div>
  </div>
}
